module.exports = __webpack_public_path__ + "media/icons/thief-circle-48-a7cbc9e9.png";